import { Inject, Injectable } from '@angular/core';
import { ScrudgService } from '../base/scrudg/scrudg.service';
import { HttpClient } from '@angular/common/http';
import { HttpFactory } from '../../utilities/http-factory';
import { EngagementStatus } from '../../models/data/talent-core/engagement-status';
import { Observable } from 'rxjs';
import { ProductionRole } from '../../models/data/talent-core/production-role';
import { RevisionSearchRequest } from '../../models/net/request/revision-search-request';
import { RevisionSearchResult } from '../../models/net/result/revision-search-result';
import { EngagementEnvelope } from '../../models/net/envelope/engagement-envelope';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';

@Injectable({
    providedIn: 'root'
})

export class EngagementService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "engagement");
    }

    public getEngagementStatuses(): Observable<EngagementStatus[] | null> {

        const result = HttpFactory.get<EngagementStatus[]>(this.http, this._controllerName + "/engagementstatuses", this._apiBaseUrl);

        return result;
    }

    public getProductionRoles(productionId: number): Observable<ProductionRole[] | null> {

        const result = HttpFactory.get<ProductionRole[]>(this.http, this._controllerName + "/productionroles/" + productionId.toString(), this._apiBaseUrl);

        return result;
    }
}
